export class ResetPasswordModel {
  public id: string;
  public newPassword: string;
  public confirmPassword: string;
  public token: string;
  public userName: string;

}
